<mat-dialog-content class="login-dialog">
	<form *ngIf="prompt === 'login'" [formGroup]="loginForm">
	  <h1>Iniciar sesión</h1>
		
		<mat-progress-bar *ngIf="isLoading" mode="indeterminate" color="accent"></mat-progress-bar>

	  <mat-form-field appearance="outline" color="accent"  >
			<mat-label>Usuario</mat-label>
			<input matInput type="text" formControlName="username" placeholder="usuario@ejemplo.com">
			<mat-icon color="primary" matSuffix>face</mat-icon>
			<mat-error  *ngIf="loginForm.controls.username.hasError('required')">Se requiere ingresar un <strong>usuario</strong></mat-error>
	  </mat-form-field>
  
	  <mat-form-field appearance="outline" color="accent">
			<mat-label>Contraseña</mat-label>
			<input matInput type="password" formControlName="password">
			<mat-icon color="primary" matSuffix>lock</mat-icon>
			<mat-error *ngIf="loginForm.controls.password.hasError('required')">Se requiere ingresar la <strong>contraseña</strong></mat-error>
	  </mat-form-field>
  
	  <button mat-raised-button color="accent" (click)="enterButton()">Entrar</button>
		<p class="errormessage" *ngIf="errorMessage != ''">{{errorMessage}}</p>
		<p class="successmessage" *ngIf="successMessage != ''">{{successMessage}}</p>
		<a (click)="goToReset()"> Olvidé mi contraseña </a>
	</form>

	<form *ngIf="prompt === 'confirmPassword'" [formGroup]="confirmPasswordForm">
	  <h1>Bienvenido</h1>
		<mat-progress-bar *ngIf="isLoading" mode="indeterminate" color="accent"></mat-progress-bar>

		<span>Por favor ingrese su nombre completo y una contraseña nueva.</span>
		<p>La contraseña debe contener números, símbolos, mayúsculas y minúsculas</p>
		
	  <mat-form-field appearance="outline" color="accent"  >
			<mat-label>Nombre completo</mat-label>
			<input matInput type="text" formControlName="name" placeholder="Jane Doe">
			<mat-icon color="primary" matSuffix>face</mat-icon>
			<mat-error  *ngIf="confirmPasswordForm.controls.name.hasError('required')">Se requiere ingresar el <strong>nombre completo</strong></mat-error>
	  </mat-form-field>
  
	  <mat-form-field appearance="outline" color="accent">
			<mat-label>Contraseña</mat-label>
			<input matInput type="password" formControlName="password">
			<mat-icon color="primary" matSuffix>lock</mat-icon>
			<mat-error *ngIf="confirmPasswordForm.controls.password.hasError('required')">Se requiere ingresar la <strong>contraseña</strong></mat-error>
	  </mat-form-field>
		
	  <mat-form-field appearance="outline" color="accent">
			<mat-label>Confirmar contraseña</mat-label>
			<input matInput type="password" formControlName="passwordConfirm">
			<mat-icon color="primary" matSuffix>lock</mat-icon>
			<mat-error *ngIf="confirmPasswordForm.controls.passwordConfirm.hasError('required')">Se requiere ingresar la confirmación de la<strong>contraseña</strong></mat-error>
	  </mat-form-field>
  
	  <button mat-raised-button color="accent" (click)="confirmPassword()">Guardar</button>
		<p class="errormessage" *ngIf="errorMessage != ''">{{errorMessage}}</p>
		<p class="successmessage" *ngIf="successMessage != ''">{{successMessage}}</p>
	</form>


	<form *ngIf="prompt === 'resetPassword'" [formGroup]="resetPasswordForm">
		<h1>Reiniciar contraseña</h1>
		<mat-progress-bar *ngIf="isLoading" mode="indeterminate" color="accent"></mat-progress-bar>
		<span>Por favor ingrese el correo electrónico de la cuenta y el nombre ingresado.</span>
		<p>Se enviará una contraseña temporal que podrá ser utilizada para el reinicio de contraseña.</p>

		<mat-form-field appearance="outline" color="accent"  >
			<mat-label>Correo electrónico</mat-label>
			<input matInput type="text" formControlName="email" placeholder="email@ejemplo.com">
			<mat-icon color="primary" matSuffix>email</mat-icon>
			<mat-error  *ngIf="resetPasswordForm.controls.email.hasError('required')">Se requiere ingresar el <strong>correo electrónico</strong></mat-error>
	  </mat-form-field>

		<mat-form-field appearance="outline" color="accent"  >
			<mat-label>Nombre del usuario</mat-label>
			<input matInput type="text" formControlName="name" placeholder="Jane Doe">
			<mat-icon color="primary" matSuffix>face</mat-icon>
			<mat-error  *ngIf="resetPasswordForm.controls.name.hasError('required')">Se requiere ingresar el <strong>nombre del usuario</strong></mat-error>
	  </mat-form-field>

		<button mat-raised-button color="accent" (click)="resetPassword()">Reiniciar</button>
		<p class="errormessage" *ngIf="errorMessage != ''">{{errorMessage}}</p>
		<p class="successmessage" *ngIf="successMessage != ''">{{successMessage}}</p>
		<a (click)="returnToLogin()"> Regresar al inicio </a>

	</form>

</mat-dialog-content>